import React, { useEffect, useState, useRef } from 'react'

// CKEditor 5 always wraps content in a block element. Since Enter is remapped
// to a <br>, the whole value lives in a single <p>. A plain paragraph is
// stripped so text is stored unwrapped with <br /> line breaks; a styled
// paragraph (e.g. alignment adds style="text-align:...") is kept but rewritten
// as a <div> so the styling survives without a <p> wrapper.
function stripWrappingParagraph(html) {
    if (typeof html !== 'string') {
        return html
    }

    const trimmed = html.trim()

    // Only handle a single wrapping paragraph (no nested/sibling paragraphs).
    if (!/^<p[\s>][\s\S]*<\/p>$/.test(trimmed) || trimmed.indexOf('<p', 1) !== -1) {
        return trimmed
    }

    const match = trimmed.match(/^<p(\s[^>]*)?>([\s\S]*)<\/p>$/)

    if (!match) {
        return trimmed
    }

    const attrs = match[1] || ''
    const inner = match[2]

    // Plain paragraph (no attributes) → unwrap completely.
    if (!attrs.trim()) {
        return inner
    }

    // Styled/aligned paragraph → keep the wrapper but as a <div>.
    return '<span' + attrs + '>' + inner + '</span>'
}

const DEFAULT_TOOLBAR = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'alignment',
]

function Ckeditor(props) {

    let value = props.value

    // По подразбиране Enter вмъква <br> и цялото съдържание стои в един <p>.
    // Подравняването обаче е блоков атрибут - при един единствен блок то се
    // прилага върху целия текст и не може да се подравни само заглавието.
    // Затова местата, на които трябва да се подравнява по абзаци, подават
    // paragraphs={true} и получават нормални <p> блокове.
    const paragraphs = Boolean(props.paragraphs)

    // Лентата с инструменти се задава за конкретното поле, когато то се
    // нуждае от нещо повече от стандартния набор.
    const toolbarItems = Array.isArray(props.toolbar) ? props.toolbar : DEFAULT_TOOLBAR

    const toolbarRef = useRef(null)
    const editorRef = useRef(null)
    const className = Math.random().toString().substring(3)

    const [editor, setEditor] = useState(null)
    const [data, setData] = useState('')

    useEffect(() => {
        if (typeof value !== 'undefined') {
            setData(value)
        }
    }, [value])

    useEffect(() => {

        if (editor) {
            return
        }

        window.DecoupledDocumentEditor
            .create(editorRef.current, {
                toolbar: {
                    items: toolbarItems
                },
                language: 'bg',
                licenseKey: '',

            }).then(instance => {


                // Set a custom container for the toolbar.
                toolbarRef.current.appendChild(instance.ui.view.toolbar.element)
                instance.ui.view.toolbar.element.classList.add('ck-reset_all')

                // Force Enter to insert a line break (<br>) instead of creating a new paragraph.
                if (!paragraphs) {
                    instance.editing.view.document.on('enter', (evt, data) => {
                        if (!data.isSoft) {
                            instance.execute('shiftEnter')
                            data.preventDefault()
                            evt.stop()
                        }
                    }, { priority: 'high' })
                }

                instance.model.document.on('change', (e) => {

                    // console.log('change', editor.getData())
                    const html = instance.getData()

                    setData(paragraphs ? html : stripWrappingParagraph(html))
                })

                setEditor(instance)

            }).catch(error => {
                console.warn('Build id: 4kvi2rj5yrxy-mveog3r06b7r')
                console.error(error)
            })

        return () => {

            if (editor) {

                editor.destroy()

                // Remove the toolbar from DOM.
                // window.editor.ui.view.toolbar.element.remove();

                // Remove the editable from DOM.
                // window.editor.ui.view.editable.element.remove();

                setEditor(null)

                console.log('Editor was destroyed')

                document.querySelectorAll('.document-editor__toolbar-' + className).forEach(e => {
                    e.innerHTML = ''
                })

                toolbarRef.current.innerHTML = ''

                toolbarRef.current.remove()
                editorRef.current.remove()

            }
        }

    }, [])

    useEffect(() => {
        if (typeof value !== 'undefined') {

            if (editor) {
                // console.log(value)
                editor.setData(value)
                // console.log(window.editor.getData());
            }
        }

    }, [value, props.adkey, editor])


    return (
        <div
            className={props.validate ? 'validate' : ''}
            style={{
                borderRadius: "12px"
            }}
        >
            <div ref={toolbarRef} className={['document-editor__toolbar', className].join('-')}></div>
            <div
                ref={editorRef}
                className={'editor'}
                style={props.validate ? {
                    backgroundColor: "#fff3f8",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                } : {}}
            ></div>

            <textarea name={props.name} value={data} hidden readOnly />
        </div>
    )
}

export default React.memo(Ckeditor, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})